import { useSearchParams } from "react-router-dom";

import { Loading } from "src/common/Loading";
import { Pagination } from "src/common/Pagination";
import { PageContent } from "src/layout/PageContent";
import {
  PageHeader,
  PageHeaderTabs,
  PageHeaderTitle,
} from "src/layout/PageHeader";
import { TabLink } from "src/layout/TabLink";
import { CellKitsFilterBar } from "src/routes/ProductUnits/CellKits/CellKitsFilterBar";
import { CellKitsTable } from "src/routes/ProductUnits/CellKits/CellKitsTable";
import { useCellKitsQuery } from "src/routes/ProductUnits/CellKits/queries";
import { INTERCOMS_URL } from "src/routes/ProductUnits/Intercoms";

export const CELL_KITS_URL = "/product-units/cell-kits";
export const CellKits = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const cellKitsQuery = useCellKitsQuery();

  return (
    <>
      <PageHeader buttons={<CellKitsFilterBar />}>
        <PageHeaderTitle>Cell Kit Inventory</PageHeaderTitle>
        <PageHeaderTabs>
          <TabLink key="intercoms" to={INTERCOMS_URL} label="Intercoms" end />
          <TabLink key="cell-kits" to={CELL_KITS_URL} label="Cell Kits" end />
        </PageHeaderTabs>
      </PageHeader>
      {!cellKitsQuery.data ? (
        <Loading />
      ) : (
        <PageContent>
          <CellKitsTable cellKits={cellKitsQuery.data.result} />

          <Pagination
            unitName="cell kit"
            total={cellKitsQuery.data.total}
            pageNumber={parseInt(searchParams.get("pageNumber") || "1")}
            pageSize={cellKitsQuery.data.pageSize}
            onPageChange={(page) => {
              setSearchParams((prev) => {
                const next = new URLSearchParams(prev);
                next.set("pageNumber", page.toFixed(0));
                return next;
              });
            }}
          />
        </PageContent>
      )}
    </>
  );
};
